import { useEffect } from "react";

/** Título y meta description de la página; se restauran al salir. */
export default function useDocumentMeta(title, description) {
  useEffect(() => {
    if (!title) return undefined;
    const prevTitle = document.title;
    document.title = title;
    return () => {
      document.title = prevTitle;
    };
  }, [title]);

  useEffect(() => {
    if (!description) return undefined;
    const meta = document.querySelector('meta[name="description"]');
    if (!meta) return undefined;
    const prev = meta.getAttribute("content");
    meta.setAttribute("content", description);
    return () => {
      if (prev != null) meta.setAttribute("content", prev);
    };
  }, [description]);
}
